export const APP_VERSION = "1.5.0 (2026-11-03)";
